import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cancel-flow__screen" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__eyebrow" }, "BEFORE YOU GO...", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "cancel-flow__main" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "cancel-flow__heading" }, "Wait! Here's something just for you..."),
  /*#__PURE__*/_createElementVNode("p", { class: "cancel-flow__body" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Get 3 months free!"),
    /*#__PURE__*/_createTextVNode(" Stay and we'll give you 3 months free on your next annual subscription. ")
  ])
], -1)
const _hoisted_4 = { class: "cancel-flow__buttons" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--primary",
        disabled: _ctx.claiming,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('claim')))
      }, "Claim this offer", 8, _hoisted_5),
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--danger",
        disabled: _ctx.claiming,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('decline')))
      }, "Confirm cancellation", 8, _hoisted_6),
      _createElementVNode("button", {
        type: "button",
        class: "cancel-flow__btn cancel-flow__btn--ghost",
        disabled: _ctx.claiming,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('stay')))
      }, "I'll stay", 8, _hoisted_7)
    ])
  ]))
}